import React, { useEffect, useState } from "react";
import { getCitas } from "../../services/citaService";
import { getMonday, addDays } from "../../utils/fechas";
import axios from "axios";

const HORA_INICIO = 9;
const HORA_FIN = 22;
const PX_HORA = 60;
const HORAS = Array.from(
  { length: HORA_FIN - HORA_INICIO },
  (_, i) => HORA_INICIO + i
);

export default function VistaSemanal({ fecha, clinica, refrescar, onSelectCita, onNuevaCita, fechaDia }) {
  const [citas, setCitas] = useState([]);

  const inicioSemana = getMonday(fecha);
  const dias = Array.from({ length: 5 }, (_, i) => addDays(inicioSemana, i));

  function agruparSolapadas(citas) {
    const grupos = [];
    citas.forEach(cita => {
      const inicio = new Date(cita.fechaInicio);
      const fin = new Date(inicio.getTime() + cita.duracionMin * 60000);

      let grupo = grupos.find(g =>
        g.some(c => {
          const i = new Date(c.fechaInicio);
          const f = new Date(i.getTime() + c.duracionMin * 60000);
          return inicio < f && fin > i;
        })
      );

      if (!grupo) {
        grupo = [];
        grupos.push(grupo);
      }

      grupo.push(cita);
    });

    return grupos;
  }

  function pintarCitasDia(citas, fechaDia, onSelect) {
    const delDia = citas.filter(c => {
      const d = new Date(c.fechaInicio);
      return d.toDateString() === fechaDia.toDateString();
    });

    const grupos = agruparSolapadas(delDia);

    return grupos.flatMap(grupo =>
      grupo.map((cita, idx) => {
        const inicio = new Date(cita.fechaInicio);
        const minutos =
          (inicio.getHours() - HORA_INICIO) * 60 +
          inicio.getMinutes();

        const top = (minutos * PX_HORA) / 60;
        const height = (cita.duracionMin * PX_HORA) / 60;
        const width = 100 / grupo.length;

        return (
          <div
            key={cita.id}
            className="cita"
            style={{
              top,
              height,
              left: `${idx * width}%`,
              width: `${width}%`,
              borderLeft: `4px solid ${cita.color || "#1890ff"}`,
              background:
                clinica === "ALL"       
                ? COLOR_CLINICA[cita.clinica]
                : "#f5faff"
            }}
            onClick={() => onSelect(cita)}
          >
            <strong>{cita.paciente}</strong>
            <div>{cita.tratamiento}</div>
          </div>
        );
      })
    );
  }

  useEffect(() => {
    getCitas({
      clinica,
      from: inicioSemana.toISOString().slice(0, 10),
      to: addDays(inicioSemana, 4).toISOString().slice(0, 10)
    }).then(setCitas);
  }, [fecha, clinica, refrescar]);

  const ahora = new Date();
  const esHoy = ahora.toDateString() === fecha.toDateString();
  const minutosDesdeInicio =
    (ahora.getHours() - HORA_INICIO) * 60 + ahora.getMinutes();

  const topHoraActual = (minutosDesdeInicio * PX_HORA) / 60;
  const hoy = new Date();
  const COLOR_CLINICA = {
    ELIPA: "#59b3f8a4", // azul suave
    VEN: "#fce3aeff"    // amarillo suave
  };
  const citasFiltradas =
    clinica === "ALL"
      ? citas
      : citas.filter(c => c.clinica === clinica);

  return (
    <div className="agenda">
      <div className="agenda-grid">
        {/* CABECERA */}
        <div className="agenda-header">
          <div className="hora-col-header"></div>
          {dias.map(d => (
            <div 
              key={d} 
              className={`dia-header ${d.toDateString() === hoy.toDateString() ? "hoy" : ""
              }`}
            >
              {d.toLocaleDateString("es-ES", {
                weekday: "long",
                day: "numeric"
              })}
            </div>
          ))}
        </div>

        {/* GRID */}
        <div className="agenda-body">
          <div className="hora-col">
            {HORAS.map(h => (
              <div
                key={h}
                className={`hora-label ${
                  esHoy && h === ahora.getHours() ? "hora-actual" : ""
                }`}               
              >
                {h}:00
              </div>
            ))}
          </div>

          <div className="dias-grid">
            {dias.map((diaFecha, col) => (
              <div key={col} className="dia-col">
                {HORAS.map(h => (
                  <div
                    key={h}
                    className="celda-hora"
                    onClick={() => onNuevaCita(diaFecha, h)}
                  />
                ))}
                {esHoy && (
                  <div
                    className="linea-hora-actual"
                    style={{ top: topHoraActual }}
                  />
                )}
                {pintarCitasDia(citasFiltradas, diaFecha, onSelectCita)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
